import { memo } from "react";

import { Stack, Typography, Container } from "@mui/material";

import WarningIcon from "@mui/icons-material/Warning";

import { COLOR } from "./../config";

import type { ComplianceWarning } from "../types";

type ComplianceComponentProps = {
  title: ComplianceWarning[];
  warnings: ComplianceWarning[];
};

const ComplianceComponent = memo((props: ComplianceComponentProps) => {
  const { warnings } = props;

  return (
    <Container maxWidth="lg" sx={{ paddingTop: 6, paddingBottom: 4 }}>
      {warnings.map(({ masterISIN, warning, title }) =>
        warning?.length > 0 ? (
          <Stack
            direction="column"  
            sx={{ border: `1px solid ${COLOR.grey9}`, marginBottom: 4 }}
            paddingX="40px"
            paddingBottom="35px"
            key={masterISIN}
          >
            <Stack
              alignSelf="center"
              direction="row"
              spacing={1}
              marginTop="-12px"
              paddingBottom="23px"
              paddingX="10px"
              bgcolor="white"
            >
              <WarningIcon />
              <Typography variant="body1" color={COLOR.grey4} fontWeight={700}>
                {title}
              </Typography>
            </Stack>
            {warning.map((line, index) => (
              <Typography
                variant="body2"
                lineHeight="normal"
                color={COLOR.grey4}
                fontWeight={600}
                key={index}
              >
                {line}
              </Typography>
            ))}
          </Stack>
        ) : (
          <></>
        ),
      )}

      {warnings.map(({ masterISIN, esmaTextOnly }) =>
        esmaTextOnly ? (
          <Stack
            direction="column"
            sx={{ marginBottom: 4 }}
            paddingX="40px"
            paddingY="20px"
            key={masterISIN}
          >
            <Typography
              variant="body2"
              lineHeight="normal"
              color={COLOR.grey4}
              fontWeight={600}
              dangerouslySetInnerHTML={{ __html: esmaTextOnly }}
            ></Typography>
          </Stack>
        ) : (
          <></>
        ),
      )}
    </Container>
  );
});

export default ComplianceComponent;
